import type {
  IUserSearchResultModel,
  IUserSearchResultViewModel,
} from "@models/user";

export const buildUserSearchResultViewModel = (
  model: IUserSearchResultModel,
): IUserSearchResultViewModel => ({
  externalId: model.external_id,
  email: model.email,
  firstName: model.first_name,
  lastName: model.last_name,
});
